@if (active) {
    @for (textBox of textBoxes; track textBox) {
        @if (textBox.isHighlighted ||
        (applicationStateService.pageEditMode && (applicationStateService.pageEditMode.type === 'SELECTION' || applicationStateService.pageEditMode.type === 'COPY'))) {
            <div
                    (mouseover)="onMouseOver()"
                    (touchmove)="onTouchMove()"
                    [attr.data-index]="textBox.index"
                    [class.highlighted]="textBox.isHighlighted"
                    [class.selected]="textBox.isSelected"
                    [ngStyle]="{
         'top.%': textBox.position.y,
         'left.%': textBox.position.x,
         'height.%': textBox.position.h,
         'width.%': textBox.position.w
     }"
                    class="text-box"
            ></div>
        }
    }
}
